import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from './firestore.service';
import type { TPickupResponse } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class PickupResponsesService {
    constructor(private firestoreService: FirestoreService,
        private firestorePathsService: FirestorePathsService) {
    }

    public getObservable(): Observable<TPickupResponse[]> {
        const path = this.firestorePathsService.getPickupResponsesPath();
        const observable = this.firestoreService.getObservable(path) as Observable<TPickupResponse[]>;
        return observable;
    }

    public async add(response: TPickupResponse): Promise<TPickupResponse> {
        const path = this.firestorePathsService.getPickupResponsesPath();
        return this.firestoreService.add(path, response);
    }

    public async set(response: TPickupResponse): Promise<TPickupResponse> {
        const path = this.firestorePathsService.getPickupResponsesPath();
        return this.firestoreService.set(path, response);
    }

    public async getAll(): Promise<TPickupResponse[]> {
        const path = this.firestorePathsService.getPickupResponsesPath();
        return this.firestoreService.getAll(path) as Promise<TPickupResponse[]>;
    }

    public async delete(responseUid: string): Promise<void> {
        const path = this.firestorePathsService.getPickupResponsesPath();
        return this.firestoreService.delete(path, responseUid);
    }

    // public async deleteAll(shuttleUid) {
    //     const responses: any = await this.getAll(shuttleUid);
    //     responses.forEach((response) => {
    //         this.delete(response.uid);
    //     });
    // }

    public async deleteOld(shuttleUid: string, milliSecs: number): Promise<number> {
        // console.log('Type mismatch');
        return new Promise((resolve) => resolve(0));
        // #type-mismatch
        // let count = 0;
        // const cutoffTime = Date.now() - milliSecs;

        // const allResponses: TPickupResponse[] = await this.getAll();
        // const responses: TPickupResponse[] = allResponses.filter(item => item.shuttleUid === shuttleUid);

        // responses.forEach(async (item) => {
        //     if (item.createdDate < cutoffTime) {
        //         await this.delete(item.uid);
        //         ++count;
        //     }
        // });
        // return count;
    }
}
